export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <rect width="16" height="16" x="4" y="4.063" fill="currentcolor" rx="2"/>
</svg>
`;
